export default {
	namespaced: true,

	state: {
		data: null,

		result: [],

		buttons: {
			debugMakeIpcEnv: {
				title: 'Make IPC env',
				description: 'Make firestore data to create ipc-only environment.',
				data: {}
			},
			debugAddAdminUser: {
				title: 'Add admin user',
				description: 'Add Admin Account in authentication and firestore.',
				data: {
					//
				}
			},
			debugResetUser: {
				title: 'Reset user',
				description: 'Reset user data in firestore.',
				data: {}
			},
			debugMoveUsersToLaravel: {
				title: 'Move users to Laravel',
				description: 'Move users in firestore to app_users in laravel.',
				data: [
					'admin'
				]
			},
			debugMovePointToLaravel: {
				title: 'Move Point to Laravel',
				description: 'Move point in cakephp to laravel.',
				data: {
					pointGiving: [
						'admin'
					],
					pointRedemption: [
						'admin'
					],
					pointReturn: [
						'admin'
					],
					pointCancellation: [
						'admin'
					],
					pointExpiration: [
						'admin'
					],
				}
			},
			debugRunGPU: {
				title: 'Run GPU',
				description: 'Run simple calculation with GPU',
				data: {
					promiseCount: 1000,
					loopCount: 1000
				}
			},
			debugSetMenuItemsFromMenus: {
				title: 'Set Menu Items From Menus',
				description: 'Set Firestore Document (contents -> app -> menuItems)',
				data: {}
			}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
